
export const compareStatisticsMap = {
  path: '/compareStatistics',
  component: () => import('@/views/compareStatistics/index.vue'),
  meta: { },
  children: [
    {
      path: 'height',
      component: () =>
        import(
          '@/views/compareStatistics/detail/height/index.vue'
        ),
      meta: { title: '身高分布' }
    },
    {
      path: 'bmi',
      meta: { title: 'BMI分布' },
      component: () =>
        import(
          '@/views/compareStatistics/detail/bmi/index.vue'
        )
    },
    {
      path: 'avg',
      meta: { title: '' },
      component: () => import('@/views/compareStatistics/detail/avg/index.vue'),
      children: [
        {
          path: 'index',
          meta: { title: '综合能力均分' },
          component: () => import('@/views/compareStatistics/detail/avg/main.vue')
        },
        {
          path: 'child',
          meta: { title: '子能区' },
          component: () => import('@/views/compareStatistics/detail/avg/child.vue')
        }
      ]
    },
    {
      path: 'distribution',
      component: () => import('@/views/compareStatistics/detail/distribution/index.vue'),
      meta: { title: '综合能力分布' }
    }
  ]
}
